// Generated prop information for LeadCaptureWidget
const propList = [
  "title",
  "description",
  "submitButtonText",
  "successMessage",
  "onSubmit",
  "show",
  "triggerPosition",
  "size",
  "zIndex",
  "xMargin",
  "yMargin",
  "hideWidget",
  "avatarSrc",
  "logoSrc",
  "logoAlt",
  "footerText",
  "termsUrl",
  "fluidShopDisplayName",
  "contactMethod",
  "attractBubbleShowDelay",
  "attractBubbleHideDelay"
];
export default propList;

// Detailed prop information with types
export const propInfo = [
  {
    "name": "title",
    "type": "string",
    "optional": true
  },
  {
    "name": "description",
    "type": "string",
    "optional": true
  },
  {
    "name": "submitButtonText",
    "type": "string",
    "optional": true
  },
  {
    "name": "successMessage",
    "type": "string",
    "optional": true
  },
  {
    "name": "onSubmit",
    "type": "string",
    "optional": true
  },
  {
    "name": "show",
    "type": "boolean",
    "optional": true
  },
  {
    "name": "triggerPosition",
    "type": "string",
    "optional": true
  },
  {
    "name": "size",
    "type": "number",
    "optional": true
  },
  {
    "name": "zIndex",
    "type": "number",
    "optional": true
  },
  {
    "name": "xMargin",
    "type": "number",
    "optional": true
  },
  {
    "name": "yMargin",
    "type": "number",
    "optional": true
  },
  {
    "name": "hideWidget",
    "type": "boolean",
    "optional": true
  },
  {
    "name": "avatarSrc",
    "type": "string",
    "optional": true
  },
  {
    "name": "logoSrc",
    "type": "string",
    "optional": true
  },
  {
    "name": "logoAlt",
    "type": "string",
    "optional": true
  },
  {
    "name": "footerText",
    "type": "string",
    "optional": true
  },
  {
    "name": "termsUrl",
    "type": "string",
    "optional": true
  },
  {
    "name": "fluidShopDisplayName",
    "type": "string",
    "optional": true
  },
  {
    "name": "contactMethod",
    "type": "string",
    "optional": true
  },
  {
    "name": "attractBubbleShowDelay",
    "type": "number",
    "optional": true
  },
  {
    "name": "attractBubbleHideDelay",
    "type": "number",
    "optional": true
  }
];
